import client from "@/services/contentfulClient";

function simplifyContentfulData(entry) {
  if (!entry || typeof entry !== "object") return entry;

  if (entry.fields) {
    const simplified = {};
    for (const key in entry.fields) {
      simplified[key] = simplifyContentfulData(entry.fields[key]);
    }
    return simplified;
  }

  if (Array.isArray(entry)) {
    return entry.map(simplifyContentfulData);
  }

  return entry;
}

export default {
  state: {},
  actions: {
    async getContentfulEntry(ctx, { entryId, locale }) {
      const fallbackEntryId = "6NQQL8TfCkj1SWtrCaLjsw";
      if (locale === "en-GB") locale = "en-UK";
      try {
        const entry = await client.getEntry(entryId || fallbackEntryId, {
          locale,
          include: 3,
        });
        let list = simplifyContentfulData(entry.fields.components);
        return list;
      } catch (error) {
        return Promise.reject({ type: "contentful", error });
      }
    },
    async getContentfulEntriesByType(ctx, { contentType, locale, query = {} }) {
      if (!contentType) return [];
      if (locale === "en-GB") locale = "en-UK";
      const response = await client.getEntries({
        content_type: contentType,
        locale,
        include: 2,
        ...query,
      });
      return response.items || [];
    },
  },
  mutations: {},
  getters: {},
};
